<template>
  <b-overlay :show="processing" rounded="sm" class="overlay-display">
    <template #overlay>
      <div class="text-center">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
        <p id="cancel-label">{{ processingMessage }}</p>
      </div>
    </template>
    <ErrorAlert
      :show="alert.error"
      :message="alert.message"
      @hide-alert="hideError"
    />
    <SuccessAlert
      :show="alert.success"
      :message="alert.message"
      @hide-alert="hideSuccess"
    />

    <div class="container-fluid p-0" id="order-reports">
      <div class="row">
        <div class="col-auto">
          <h3><strong>Order Replacement Automation</strong></h3>
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-12 col-xl-12 col-12">
          <div class="form-card">
            <b-form id="order-report-form">
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <b-form-input
                      id="input-1"
                      v-model="order.orderId"
                      @keyup.enter="query"
                      type="text"
                      maxlength="10"
                      placeholder="Please input Order Name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-button
                    type="button"
                    variant="primary"
                    class="submit-button"
                    @click="query"
                  >
                    Query Order
                  </b-button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Province: ({{ order.province }})</label
                    >
                    <b-form-select
                      v-model="form.province"
                      :options="provincesOpt"
                      @change="selectProvince"
                      :state="formSubmitted ? !!form.province : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.province"
                      class="invalid-feedback d-block"
                    >
                      Province is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >City: ({{ order.city }})</label
                    >
                    <v-select
                      :options="citiesOpt"
                      v-model="form.city"
                      @input="selectCity"
                      :class="[
                        'input-height',
                        'mt-1',
                        formSubmitted && !form.city ? 'is-invalid-vselect' : ''
                      ]"
                    ></v-select>
                    <div
                      v-if="formSubmitted && !form.city"
                      class="invalid-feedback d-block"
                    >
                      City is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Region: ({{ order.region }})</label
                    >
                    <b-form-input
                      v-model="form.region"
                      type="text"
                      readonly
                      placeholder="Region"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Delivery date: ({{ order.deliveryDate }})</label
                    >
                    <b-form-datepicker
                      :key="datepickerKey"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                      }"
                      v-model="form.deliveryDateNew"
                      :date-disabled-fn="dateDisabled"
                      @input="queryProducts"
                      :state="formSubmitted ? !!form.deliveryDateNew : null"
                      class="mb-2"
                      required
                    ></b-form-datepicker>
                    <div
                      v-if="formSubmitted && !form.deliveryDateNew"
                      class="invalid-feedback d-block"
                    >
                      Delivery date is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Postal Code: ({{ order.postalCode }})</label
                    >
                    <b-form-input
                      v-model="form.postalCode"
                      :state="
                        formSubmitted
                          ? postalCodeState
                          : form.postalCode
                          ? postalCodeState
                          : null
                      "
                      @blur="queryDeliveryWindow"
                      maxlength="7"
                      type="text"
                      placeholder="Please input Postal Code"
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="formSubmitted && !postalCodeState"
                      class="invalid-feedback d-block"
                    >
                      {{
                        !form.postalCode
                          ? "Postal Code is required"
                          : "Postal Code is invalid"
                      }}
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Lang: ({{ order.lang }})</label
                    >
                    <b-form-select
                      v-model="form.lang"
                      :options="langOpt"
                      @change="queryDeliveryWindow"
                      :state="formSubmitted ? !!form.lang : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.lang"
                      class="invalid-feedback d-block"
                    >
                      Lang is required
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >First Name: ({{ order.firstName }})</label
                    >
                    <b-form-input
                      v-model="form.firstName"
                      type="text"
                      maxlength="28"
                      placeholder="Please input First Name"
                      :state="formSubmitted ? !!form.firstName : null"
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="formSubmitted && !form.firstName"
                      class="invalid-feedback d-block"
                    >
                      First Name is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Last Name: ({{ order.lastName }})</label
                    >
                    <b-form-input
                      v-model="form.lastName"
                      type="text"
                      maxlength="28"
                      placeholder="Please input Last Name"
                      :state="formSubmitted ? !!form.lastName : null"
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="formSubmitted && !form.lastName"
                      class="invalid-feedback d-block"
                    >
                      Last Name is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Contact Name: ({{ order.cname }})</label
                    >
                    <b-form-input
                      v-model="form.cName"
                      type="text"
                      maxlength="28"
                      placeholder="Please input Contact Name"
                      :state="formSubmitted ? !!form.cName : null"
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="formSubmitted && !form.cName"
                      class="invalid-feedback d-block"
                    >
                      Contact Name is required
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Relationship: ({{ order.relationship }})</label
                    >
                    <b-form-select
                      v-model="form.relationship"
                      :options="relationshipsOpt"
                      :state="formSubmitted ? !!form.relationship : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.relationship"
                      class="invalid-feedback d-block"
                    >
                      Relationship is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Occasion: ({{ order.occasion }})</label
                    >
                    <b-form-select
                      v-model="form.occasion"
                      :options="occasionsOpt"
                      :state="formSubmitted ? !!form.occasion : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.occasion"
                      class="invalid-feedback d-block"
                    >
                      Occasion is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Address Type: ({{ order.addressType }})</label
                    >
                    <b-form-select
                      v-model="form.addressType"
                      :options="addressTypesOpt"
                      :state="formSubmitted ? !!form.addressType : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.addressType"
                      class="invalid-feedback d-block"
                    >
                      Address Type is required
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Address: ({{ order.address }})</label
                    >
                    <b-form-input
                      id="address-autocomplete-replacement"
                      ref="addressInput"
                      v-model="form.address"
                      type="text"
                      maxlength="150"
                      placeholder="Please input Address"
                      :state="formSubmitted ? !!form.address : null"
                      class="input-height mt-1"
                      @input="extractPostalCodeFromAddress"
                    ></b-form-input>
                    <div
                      v-if="formSubmitted && !form.address"
                      class="invalid-feedback d-block"
                    >
                      Address is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Apartment Number: ({{ order.apartmentNumber }})</label
                    >
                    <b-form-input
                      v-model="form.apartmentNumber"
                      type="text"
                      maxlength="50"
                      placeholder="Please input Apartment Number"
                      :state="
                        isApartmentType && formSubmitted
                          ? !!form.apartmentNumber
                          : null
                      "
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="
                        isApartmentType &&
                          formSubmitted &&
                          !form.apartmentNumber
                      "
                      class="invalid-feedback d-block"
                    >
                      Apartment Number is required for Apartment/Condo
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Buzzer Code: ({{ order.buzzerCode }})</label
                    >
                    <b-form-input
                      v-model="form.buzzerCode"
                      type="text"
                      maxlength="20"
                      placeholder="Please input Buzzer Code"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Delivery Window: ({{ order.deliveryRate }})</label
                    >
                    <b-form-select
                      v-model="form.deliveryRate"
                      :options="shippingMethodsOpt"
                      :state="formSubmitted ? !!form.deliveryRate : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.deliveryRate"
                      class="invalid-feedback d-block"
                    >
                      Delivery Window is required
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Phone Number: ({{ order.phone }})</label
                    >
                    <b-form-input
                      v-model="form.phoneNumber"
                      type="text"
                      maxlength="14"
                      :state="
                        formSubmitted
                          ? isPhoneNumberValid(form.phoneNumber)
                          : form.phoneNumber
                          ? isPhoneNumberValid(form.phoneNumber)
                          : null
                      "
                      @blur="
                        form.phoneNumber = formatPhoneNumber(form.phoneNumber)
                      "
                      placeholder="Please input Phone Number"
                      class="input-height mt-1"
                    ></b-form-input>
                    <div
                      v-if="
                        formSubmitted && !isPhoneNumberValid(form.phoneNumber)
                      "
                      class="invalid-feedback d-block"
                    >
                      {{
                        !form.phoneNumber
                          ? "Phone Number is required"
                          : "Please enter a valid 10-digit phone number"
                      }}
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Consent: ({{ order.consent }})</label
                    >
                    <b-form-select
                      v-model="form.consent"
                      :options="consentOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Bouquet Name: ({{ order.bouquetName }})</label
                    >
                    <b-form-select
                      v-model="form.bouquetName"
                      :options="bouquetOpt"
                      @change="selectBouquet"
                      :state="formSubmitted ? !!form.bouquetName : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.bouquetName"
                      class="invalid-feedback d-block"
                    >
                      Bouquet Name is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Bouquet Size: ({{ order.bouquetSize }})</label
                    >
                    <b-form-select
                      v-model="form.bouquetSize"
                      :options="bouquetSizesOpt"
                      :state="formSubmitted ? !!form.bouquetSize : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.bouquetSize"
                      class="invalid-feedback d-block"
                    >
                      Bouquet Size is required
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Vase: ({{ order.vase }})</label
                    >
                    <b-form-select
                      v-model="form.vase"
                      :options="vaseOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row mt-3">
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Addons Inventory:</label>
                    <b-form-select
                      v-model="addons"
                      :options="addonsInventoryOpt"
                      :select-size="6"
                      @dblclick.native="selectAddon"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="w-10">
                  <b-button-group vertical>
                    <label class="mt-1 report-label">Options</label>
                    <br />
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="selectAddon"
                    >
                      &gt;&gt;
                    </b-button>
                    <b-button
                      type="button"
                      variant="primary"
                      class="button"
                      @click="unselectAddon"
                    >
                      &lt;&lt;
                    </b-button>
                  </b-button-group>
                </div>
                <div class="w-45 col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Order Addons: ({{ order.addons }})</label
                    >
                    <b-form-select
                      v-model="form.addons"
                      :options="addonsOpt"
                      :select-size="6"
                      @dblclick.native="unselectAddon"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Delivery Notes: ({{ order.deliveryNotes }})</label
                    >
                    <b-form-input
                      v-model="form.deliveryNotes"
                      type="text"
                      maxlength="200"
                      placeholder="Please input Delivery Notes"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Card Type: ({{ order.cardType }})</label
                    >
                    <b-form-select
                      v-model="form.cardType"
                      :options="cardOpt"
                      :state="formSubmitted ? !!form.cardType : null"
                      class="input-height mt-1"
                    ></b-form-select>
                    <div
                      v-if="formSubmitted && !form.cardType"
                      class="invalid-feedback d-block"
                    >
                      Card Type is required
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Card Message (Maximum 900 characters)</label
                    >
                    <b-form-select
                      v-model="form.messageTemplate"
                      :options="messageTemplateOpt"
                      @change="applyMessageTemplate"
                      class="input-height mb-2"
                    ></b-form-select>
                    <b-form-textarea
                      v-model="form.message"
                      rows="3"
                      max-rows="8"
                      :state="
                        formSubmitted
                          ? !!form.message && form.message.length <= 900
                          : form.message
                          ? form.message.length <= 900
                          : null
                      "
                      placeholder="Please input Message"
                    ></b-form-textarea>
                    <div
                      v-if="formSubmitted && !form.message"
                      class="invalid-feedback d-block"
                    >
                      Card Message is required
                    </div>
                    <div
                      v-if="
                        formSubmitted &&
                          form.message &&
                          form.message.length > 900
                      "
                      class="invalid-feedback d-block"
                    >
                      Card Message must be 900 characters or fewer
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Discount Code:</label>
                    <b-form-input
                      v-model="form.discountCode"
                      type="text"
                      placeholder="Please input Discount Code"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Order Notes:</label>
                    <b-form-input
                      v-model="form.note"
                      type="text"
                      placeholder="Please input Order Notes"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 report-label"
                      >Email: ({{ order.email }})</label
                    >
                    <b-form-select
                      v-model="form.email"
                      :options="emailOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Notes to original order:</label
                    >
                    <b-form-input
                      v-model="form.noteToOriginalOrder"
                      type="text"
                      placeholder="Please input notes to original order"
                      class="input-height mt-1"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <!-- Sender Reachout -->
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label"
                      >Send reachout email to sender</label
                    >
                    <b-form-checkbox
                      v-model="senderReachout.enabled"
                      value="true"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
              <div v-if="senderReachout.enabled === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Reachout Type</label>
                    <b-form-select
                      v-model="senderReachout.cannedType"
                      :options="senderReachoutOpt"
                      @change="onSenderReachoutSelect"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div v-if="senderReachout.enabled === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Email Subject</label>
                    <b-form-input
                      v-model="senderReachout.subject"
                      type="text"
                      placeholder="Please input Email Subject"
                      class="input-height mt-1"
                      ref="senderReachoutSubject"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div v-if="senderReachout.enabled === 'true'" class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Email Body</label>
                    <b-form-textarea
                      v-model="senderReachout.body"
                      rows="5"
                      max-rows="10"
                      placeholder="Please input Email Body"
                      ref="senderReachoutBody"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </div>
              <!-- End Sender Reachout -->

              <div class="row mt-3">
                <div class="col-sm">
                  <b-input-group class="mt-1" prepend="Subtotal $">
                    <b-form-input
                      v-model="subtotal"
                      type="text"
                      readonly
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <b-button
                      type="button"
                      variant="primary"
                      class="submit-button mb-2 mb-lg-0"
                      @click="createOrder"
                    >
                      Create new order
                    </b-button>
                    &nbsp;&nbsp;&nbsp;
                    <b-button
                      type="button"
                      variant="primary"
                      class="submit-button"
                      @click="scrollToTop"
                    >
                      Scroll to top
                    </b-button>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Result</label>
                    <b-form-textarea
                      v-model="result"
                      rows="8"
                      type="text"
                      readonly
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
      <div class="page-break"></div>
    </div>
  </b-overlay>
</template>

<script>
import dayjs from "dayjs";
import ToastMixin from "@/mixin/toast-mixin";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";
import {
  getAllCities,
  getCutoffs,
  getOccasions,
  getRelationships
} from "@/utils/queryUtil";

import FormatMixin from "@/mixin/format-mixin";

export default {
  mixins: [FormatMixin, ToastMixin],
  components: {
    ErrorAlert,
    SuccessAlert,
    "v-select": vSelect
  },
  computed: {
    datepickerKey() {
      return `${this.availableDates.length}-${this.unavailableDates.length}-${this.closedDays.length}`;
    },
    postalCodeState() {
      return this.form.postalCode && this.form.postalCode.length >= 6
        ? true
        : false;
    },
    isApartmentType() {
      return this.form.addressType === "Apartment/Condo";
    },
    subtotal() {
      let price = 0;
      try {
        if (this.form.deliveryRate && this.shippingMethodsOpt) {
          console.log("deliveryRate:", this.form.deliveryRate);
          const deliveryRateObj = this.shippingMethodsOpt.find(
            item => item.value === this.form.deliveryRate
          );
          if (deliveryRateObj && deliveryRateObj.price) {
            price += parseFloat(deliveryRateObj.price.replace("$", ""));
          } else {
            console.log("Could not find deliveryRate:", this.form.deliveryRate);
          }
        }
        if (this.form.vase && this.vaseOpt) {
          const vaseObj = this.vaseOpt.find(
            item => item.value === this.form.vase
          );
          if (vaseObj && vaseObj.price) {
            price += parseFloat(vaseObj.price);
          }
        }
        if (this.form.cardType && this.cardOpt) {
          const cardType =
            this.order.cardType === "Blank Card"
              ? "Flowers"
              : this.order.cardType;
          let cardTypeObj = this.cardOpt.find(item => item.value === cardType);
          if (!cardTypeObj) {
            cardTypeObj = this.cardOpt.find(
              item => item.value.value === "Flowers"
            );
            console.log("card type obj new:", cardTypeObj);
          }
          if (cardTypeObj && cardTypeObj.price) {
            price += parseFloat(cardTypeObj.price);
          }
        }
        if (this.addonsOpt && this.addonsOpt.length > 0) {
          for (const addon of this.addonsOpt) {
            if (addon && addon.value && addon.value.price) {
              price += parseFloat(addon.value.price) * addon.value.quantity;
            }
          }
        }
        if (this.form.bouquetSize && this.bouquetSizesOpt) {
          const bouquetObj = this.bouquetSizesOpt.find(
            item => item.value === this.form.bouquetSize
          );
          if (bouquetObj && bouquetObj.price) {
            price += parseFloat(bouquetObj.price);
          }
        }
      } catch (e) {
        console.error("subtotal error:", e);
      }
      return `${price}`;
    }
  },
  data() {
    return {
      processing: false,
      processingMessage: "Please wait...",
      productsQueryURL: "https://shop.callia.com/products/query",
      result: "",
      autocomplete: null,
      googleMapsLoaded: false,
      order: {
        orderId: "",
        deliveryDate: "",
        region: "",
        tags: "",
        firstName: "",
        lastName: "",
        address: "",
        postalCode: "",
        addressType: "",
        apartmentNumber: "",
        city: "",
        province: "",
        deliveryRate: "",
        deliveryNotes: "",
        message: "",
        cardType: "",
        bouquetName: "",
        bouquetSize: "",
        addons: [],
        vase: null,
        regionCode: ""
      },
      form: {
        firstName: "",
        lastName: "",
        address: "",
        postalCode: "",
        addressType: "",
        apartmentNumber: "",
        city: "",
        province: "",
        deliveryDate: "",
        deliveryDateNew: "",
        deliveryRate: "",
        deliveryNotes: "",
        message: "",
        cardType: "",
        bouquetName: "",
        bouquetSize: "",
        giftSetName: "",
        addons: "",
        vase: "",
        consent: "No",
        phoneNumber: "",
        cName: "",
        discountCode: "",
        note: "",
        lang: "en-ca",
        regionCode: "",
        email: "caitlin@calliaflowers.com",
        messageTemplate: ""
      },
      addons: "",

      alert: {
        error: false,
        message: ""
      },

      shippingMethodsOpt: [{ text: "Select an option", value: null }],

      addressTypesOpt: [
        { text: "Select an option", value: null },
        { text: "House", value: "House" },
        { text: "Apartment/Condo", value: "Apartment/Condo" },
        { text: "Business", value: "Business" },
        { text: "Hospital", value: "Hospital" }
      ],

      relationshipsOpt: [
        { text: "Select an option", value: null },
        { text: "Partner", value: "Partner" },
        { text: "Friend", value: "Friend" },
        { text: "Mom", value: "Mom" },
        { text: "Grandparent", value: "Grandparent" },
        { text: "Family member", value: "Family member" },
        { text: "Colleague", value: "Colleague" },
        { text: "Client", value: "Client" },
        { text: "Myself", value: "Myself" },
        { text: "Other", value: "Other" }
      ],

      occasionsOpt: [
        { text: "Select an option", value: null },
        { text: "Birthday", value: "Birthday" },
        { text: "Anniversary", value: "Anniversary" },
        { text: "Celebration", value: "Celebration" },
        { text: "Engagement", value: "Engagement" },
        { text: "Just because", value: "Just because" },
        { text: "Sympathy", value: "Sympathy" },
        { text: "Thinking of you", value: "Thinking of you" },
        { text: "Self-care", value: "Self-care" },
        { text: "Other", value: "Other" }
      ],

      bouquetSizesOpt: [{ text: "Select an option", value: null }],

      bouquetOpt: [],
      bouquetFlatOpt: [],
      addonsInventoryOpt: [],
      addonsOpt: [],
      vaseOpt: [],
      cardOpt: [],
      bouquetSizeObj: {},
      consentOpt: {
        Yes: "Yes",
        No: "No"
      },
      messageTemplateOpt: [
        { text: "-- Select a template or type a custom message --", value: "" },
        {
          text: "Minibouquet",
          value:
            "A little birdie mentioned those blooms weren't looking their best, so we wanted to send some fresh ones your way on us. Hope these brighten your day a little more 💛"
        },
        {
          text: "Full Replacement",
          value:
            "We heard those blooms may not have arrived quite as beautifully as intended, so here's a fresh bouquet on us 💐 Hope these ones make things right and bring a little extra joy your way!"
        },
        {
          text: "Vase Replacement",
          value:
            "A little birdie mentioned there was an issue with the vase that should've been included! Here's one now so your blooms have the perfect home 💐"
        },
        {
          text: "Missing Add-on",
          value:
            "Oops! Looks like a little something got left behind on the original delivery ✨ We wanted to make sure you received it properly. Enjoy, with love from our team 💛"
        }
      ],
      langOpt: [
        { text: "CA-EN", value: "en-ca" },
        { text: "CA-FR", value: "fr-ca" }
      ],
      text2EmailLangObj: {
        "ca-en": "en-ca",
        "ca-fr": "fr-ca"
      },
      email2TextLangObj: {
        "en-ca": "ca-en",
        "fr-ca": "ca-fr"
      },
      provincesOpt: [],
      citiesOpt: [],
      provinceMap: {
        Manitoba: "MB",
        Saskatchewan: "SK",
        Alberta: "AB",
        "British Columbia": "BC",
        Ontario: "ON",
        Maritimes: "HX",
        Québec: "QC",
        Quebec: "QC",
        "Nova Scotia": "NB",
        "Prince Edward Island": "PE",
        "New Brunswick": "NB"
      },
      provinceCityObj: {},
      cityRegionObj: {},
      allCitiesObj: {},
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      cutoffTime: [],
      emailOpt: [],
      defaultEmailOpt: [],
      lastQueryParams: null,
      formSubmitted: false,
      senderReachout: {
        enabled: "false",
        cannedType: "",
        subject: "",
        body: ""
      },
      senderReachoutOpt: [
        { text: "-- Select a reachout type --", value: "" },
        { text: "Minibouquet", value: "Minibouquet" },
        { text: "Full Replacement", value: "FullReplacement" },
        { text: "Missing Add-on", value: "MissingAddon" }
      ]
    };
  },
  async mounted() {
    this.queryCities();
    this.queryOccasions();
    this.queryRelationships();
    const user = this.$store.getters.currentUser;
    this.defaultEmailOpt.push({
      text: "caitlin@calliaflowers.com",
      value: "caitlin@calliaflowers.com"
    });
    this.defaultEmailOpt.push({ text: user.email, value: user.email });

    // Load Google Maps API and initialize autocomplete
    await this.loadGoogleMapsAPI();
  },
  beforeDestroy() {
    // Clean up Google Maps listeners
    if (this.autocomplete) {
      window.google?.maps?.event?.clearInstanceListeners(this.autocomplete);
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async queryRelationships() {
      const response = await getRelationships();
      if (response) {
        const relationships = [{ text: "Select an option", value: null }];
        this.relationshipsOpt = response.split(",").map(res => {
          return { text: res.trim(), value: res.trim() };
        });
        this.relationshipsOpt = relationships.concat(this.relationshipsOpt);
      }
    },
    async queryOccasions() {
      const response = await getOccasions();
      const occasions = response?.data?.occasions;
      if (occasions && occasions[0]["occasion-types"]) {
        this.occasionsOpt = [];
        this.occasionsOpt.push({ text: "Select an option", value: "" });
        for (const occasionObj of occasions[0]["occasion-types"]) {
          const occasion = {
            text: occasionObj["occasion-name"],
            value: occasionObj["occasion-name"]
          };
          this.occasionsOpt.push(occasion);
        }
      }
    },
    async query() {
      if (!this.order.orderId) {
        this.displayMessage("warning", `Order Name can't be empty`);
        return false;
      }

      this.processing = true;
      this.formSubmitted = false;
      this.senderReachout = {
        enabled: "false",
        cannedType: "",
        subject: "",
        body: ""
      };
      this.displayMessage("Success", "Getting order data...");

      try {
        this.form.bouquetName = null;
        const orderName = this.order.orderId.replace("#", "").trim();
        const url =
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
          "/pull-automation/order/" +
          orderName;
        const response = await this.axios
          .get(url)
          .then(res => {
            console.log("response:", res);
            if (res && res.data) {
              return res.data;
            } else {
              this.displayMessage(
                "warning",
                `Query Exception: Please try again or re-login.`
              );
            }
          })
          .catch(err => {
            this.displayMessage("warning", `Query Exception: ${err}`);
          });
        if (!response) {
          this.processing = false;
          return;
        }
        this.order = response;

        if (this.order.province) {
          this.form.province = this.order.province
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          this.selectProvince();
          if (this.order.city) {
            this.form.regionCode = this.order.regionCode;
            const normalizedCity = this.order.city
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            // citiesOpt entries are in "CityName(regionCode)" format — find the matching one
            const cityOption =
              this.citiesOpt.find(c => {
                const cityName = c.split("(")[0].trim();
                return cityName.toLowerCase() === normalizedCity.toLowerCase();
              }) ||
              this.citiesOpt.find(c => {
                const cityName = c
                  .split("(")[0]
                  .trim()
                  .toLowerCase();
                const search = normalizedCity.toLowerCase();
                return cityName.includes(search) || search.includes(cityName);
              });
            this.form.city = cityOption || normalizedCity;
            await this.selectCity();
          }
        }

        this.form.postalCode = this.order.postalCode;
        this.form.lang = this.text2EmailLangObj[this.order.lang?.toLowerCase()];
        const deliveryDate = dayjs.tz(
          this.order.deliveryDate,
          "America/Winnipeg"
        );
        const currentTimeStamp = dayjs().tz("America/Winnipeg");
        const today = currentTimeStamp.startOf("day");
        this.form.deliveryDateNew = deliveryDate.format("YYYY-MM-DD");
        if (deliveryDate.isBefore(today)) {
          this.displayMessage("warning", `Please select delivery date`);
        } else {
          await this.queryProducts();
        }

        if (this.order && this.order.bouquetName) {
          console.log("bouquet name:", this.order.bouquetName);
          if (this.order.bouquetName.includes("-")) {
            this.order.bouquetSize = this.order.bouquetName
              .split("-")[1]
              .trim();
            this.order.bouquetName = this.order.bouquetName
              .split("-")[0]
              .trim();
            this.form.bouquetName = this.order.bouquetName;
            this.selectBouquet();
            this.form.bouquetSize = this.order.bouquetSize;
          }
        } else {
          console.log("bouquet name empty", this.order);
        }
        this.addonsOpt.length = 0;
        if (this.order.addons) {
          const addons = this.order.addons.split(",");
          for (const addon of addons) {
            let addonStr = addon;
            let addonQuantity = 1;
            if (addon.includes("(")) {
              addonStr = addon.split("(")[0].trim();
              addonQuantity = parseInt(
                addon
                  .split("(")[1]
                  .trim()
                  .replace(/\s|[)]|x/g, "")
              );
            }
            const orderAddonsObj = this.addonsInventoryOpt.find(
              item => item.value.value === addonStr
            );
            if (orderAddonsObj) {
              this.addonsOpt.push({
                text: `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price} (x${addonQuantity})`,
                value: {
                  value: orderAddonsObj.value.value,
                  id: orderAddonsObj.value.id,
                  price: orderAddonsObj.value.price,
                  quantity: addonQuantity,
                  quantityAvailable: orderAddonsObj.value.quantityAvailable
                }
              });
            }
          }
        }
        this.form.vase = "";
        if (this.order.vase) {
          if (this.vaseOpt.find(item => item.value === this.order.vase)) {
            this.form.vase = this.order.vase;
          }
        }

        this.form.deliveryRate = this.order.deliveryRate;
        this.form.addressType = this.order.addressType;
        this.form.address = this.order.address;
        this.form.buzzerCode = this.order.buzzerCode;
        this.form.apartmentNumber = this.order.apartmentNumber;
        this.form.consent = this.order.consent;
        this.form.phoneNumber = this.order.phone;
        this.form.firstName = this.order.firstName;
        this.form.lastName = this.order.lastName;
        this.form.cName = this.order.cname || this.order.cName;
        this.form.relationship = this.order.relationship;
        this.form.occasion = this.order.occasion;
        // this.form.cardType = this.order.cardType;
        this.form.deliveryNotes = this.order.deliveryNotes;
        this.form.message = this.order.message;

        this.form.cardType =
          this.order.cardType === "Blank Card"
            ? "Flowers"
            : this.order.cardType;
        this.emailOpt = [...this.defaultEmailOpt];
        this.emailOpt.push({ text: this.order.email, value: this.order.email });
        this.form.email = this.order.email;
      } catch (e) {
        console.error("query error:", e);
      }

      this.processing = false;
    },

    async queryCities() {
      // this.displayMessage("Success", "Getting cities...");
      const response = await getAllCities();
      if (response) {
        this.allCitiesObj = response;
        for (const key of Object.keys(response)) {
          const provinceName = key;
          const cities = [];
          const province = { text: provinceName, value: provinceName };
          for (const val of response[key]) {
            for (const city of val.cities) {
              cities.push(`${city.name}(${val.shortCode})`);
              this.cityRegionObj[`${city.name}(${val.shortCode})`] =
                val.regionTag;
            }
          }
          this.provincesOpt.push(province);
          this.provinceCityObj[provinceName] = cities.sort((a, b) =>
            a > b ? 1 : -1
          );
        }
        this.provincesOpt = this.provincesOpt.sort((a, b) =>
          a.value > b.value ? 1 : -1
        );
        // this.displayMessage("Success", "Query Cities: Done...");
        return true;
      } else {
        this.displayMessage("warning", `queryCities Exception`);
      }
    },
    selectProvince() {
      this.form.city = "";
      this.citiesOpt = this.provinceCityObj[this.form.province];
    },
    async selectCity() {
      this.form.region = "";
      if (this.form.city) {
        this.form.region = this.cityRegionObj[this.form.city];
        console.log("region:", this.form.region);
        this.lastQueryParams = null;
        await this.queryCutoffs();
        this.form.deliveryDateNew = "";
      }
    },

    async queryCutoffs() {
      // this.displayMessage("Success", "Getting cutoffs...");
      const region = this.form.region;
      if (!region) {
        this.displayMessage("warning", `Please select region`);
        return;
      }
      const cutoffs = await getCutoffs(region);
      if (cutoffs) {
        if (cutoffs.closedDates) {
          this.closedDays = cutoffs.closedDates.map(closeD => parseInt(closeD));
        }
        this.form.regionCode =
          cutoffs.region?.toUpperCase() || this.form.regionCode;
        this.unavailableDates = cutoffs.un_available;
        this.availableDates = cutoffs.available;
        this.cutoffTime = cutoffs.cutoff_time;
        // this.displayMessage("Success", "Cutoffs done...");
        return true;
      } else {
        this.displayMessage("warning", `queryCutoffs Exception`);
      }
    },

    async queryProducts() {
      if (!this.form.deliveryDateNew) {
        this.displayMessage("warning", `Please select delivery date`);
        return;
      }
      const deliveryDate = dayjs(this.form.deliveryDateNew);
      const weekNum = this.extractWeekNumber(deliveryDate);
      const warehouseCode = this.form.regionCode;

      if (!warehouseCode) {
        console.log("regionCode not set yet, skipping queryProducts");
        return;
      }

      if (this.form.postalCode && this.form.postalCode.length >= 6) {
        await this.queryDeliveryWindow();
      }

      // Skip if same warehouse+week combo — inventory doesn't change within a week
      const currentParams = `${warehouseCode}-${weekNum}`;
      if (this.lastQueryParams === currentParams) {
        console.log("Same week number, skipping product query");
        return;
      }

      this.bouquetOpt.length = 0;
      this.bouquetFlatOpt.length = 0;
      this.bouquetOpt.push({ text: "Select an option", value: "" });
      this.bouquetSizeObj = {};
      // this.displayMessage("Success", "Getting bouquets...");
      await this.queryBouquets(warehouseCode, weekNum, "Flowers");
      // this.displayMessage("Success", "Getting Bundle...");
      await this.queryBouquets(warehouseCode, weekNum, "Bundle");
      // this.displayMessage("Success", "Getting Curated_Bundle...");
      await this.queryBouquets(warehouseCode, weekNum, "Curated_Bundle");
      // this.displayMessage("Success", "Getting vases...");
      await this.queryVases(warehouseCode, weekNum);
      // this.displayMessage("Success", "Getting addons...");
      await this.queryAddons(warehouseCode, weekNum);
      // this.displayMessage("Success", "Getting cards...");
      await this.queryCard(warehouseCode, weekNum);
      this.lastQueryParams = currentParams;
      // Re-match form values against the newly loaded inventory
      this.reSelectProducts();
      // this.displayMessage("Success", "Query Products Done...");
    },

    reSelectProducts() {
      // Re-select bouquet name from new inventory
      if (this.form.bouquetName) {
        const bouquetMatch = this.bouquetFlatOpt.find(
          item => item.value === this.form.bouquetName
        );
        if (bouquetMatch) {
          // Re-trigger selectBouquet to reload size options
          this.bouquetSizesOpt = this.bouquetSizeObj[this.form.bouquetName] || [
            { text: "Select an option", value: "" }
          ];
          // Re-select bouquet size
          if (this.form.bouquetSize) {
            const sizeMatch = this.bouquetSizesOpt.find(
              item => item.value === this.form.bouquetSize
            );
            if (!sizeMatch) {
              this.form.bouquetSize = "";
            }
          }
        } else {
          console.log(
            "Bouquet not available for new date:",
            this.form.bouquetName
          );
          this.form.bouquetName = "";
          this.form.bouquetSize = "";
          this.bouquetSizesOpt = [{ text: "Select an option", value: "" }];
        }
      }

      // Re-select vase from new inventory
      if (this.form.vase) {
        const vaseMatch = this.vaseOpt.find(
          item => item.value === this.form.vase
        );
        if (!vaseMatch) {
          console.log("Vase not available for new date:", this.form.vase);
          this.form.vase = "";
        }
      }

      // Re-select card type from new inventory
      if (this.form.cardType) {
        const cardMatch = this.cardOpt.find(
          item => item.value === this.form.cardType
        );
        if (!cardMatch) {
          console.log("Card not available for new date:", this.form.cardType);
          this.form.cardType = "";
        }
      }

      // Re-validate addons: keep only those still available in new inventory
      if (this.addonsOpt && this.addonsOpt.length > 0) {
        this.addonsOpt = this.addonsOpt.filter(addon => {
          const inventoryMatch = this.addonsInventoryOpt.find(
            item => item.value.value === addon.value.value
          );
          if (!inventoryMatch) {
            console.log("Addon not available for new date:", addon.value.value);
            return false;
          }
          return true;
        });
      }
    },

    async queryDeliveryWindow() {
      if (!this.form.postalCode) {
        this.displayMessage("warning", `Please input postal code`);
        return;
      }
      if (this.form.postalCode.length < 6) {
        this.displayMessage("warning", `Postal code is incorrect`);
        return;
      }
      if (!this.form.lang) {
        this.displayMessage("warning", `Please select Lang`);
        return;
      }
      if (!this.form.deliveryDateNew) {
        this.displayMessage("warning", `Please select delivery date`);
        return;
      }

      // this.displayMessage("Success", "Getting Delivery window...");
      this.form.postalCode = this.form.postalCode.toUpperCase();
      await this.queryDeliveryRates(
        this.form.postalCode,
        this.form.deliveryDateNew,
        this.form.lang
      );
      // this.displayMessage("Success", "Query Delivery window: Done...");
    },
    async queryBouquets(warehouseCode, weekNum, productType) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const data = {
        queryId: "products_filter",
        productType: productType,
        region: warehouseCode,
        dateCode: weekNum
      };
      const bouquetList = await this.axios
        .post(inventoryUrl, data)
        .then(res => {
          console.log("Inventory response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryBouquets Exception: ${err}`);
        });
      if (bouquetList) {
        const bouquetOpt = [];
        for (const bouquet of bouquetList) {
          if (bouquet.node.availableForSale) {
            bouquetOpt.push({
              text: bouquet.node.title,
              value: bouquet.node.title
            });
            this.bouquetFlatOpt.push({
              text: bouquet.node.title,
              value: bouquet.node.title
            });
            const variantOpt = [];
            variantOpt.push({ text: "Select an option", value: "" });
            for (const variant of bouquet.node.variants.edges) {
              variantOpt.push({
                text: `${variant.node.title} - $${variant.node.price.amount} (${variant.node.quantityAvailable})`,
                value: variant.node.title,
                id: variant.node.id,
                sku: variant.node.sku,
                price: variant.node.price.amount
              });
            }
            this.bouquetSizeObj[bouquet.node.title] = variantOpt;
          }
        }
        this.bouquetOpt.push({
          label: productType,
          options: bouquetOpt
        });
      } else {
        console.log("bouquetList is null");
      }
    },
    async queryVases(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const vaseData = {
        queryId: "products_with_product_type_filter",
        productType: "Vase",
        region: warehouseCode,
        dateCode: weekNum
      };
      const vaseList = await this.axios
        .post(inventoryUrl, vaseData)
        .then(res => {
          console.log("query vase response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (vaseList) {
        this.vaseOpt.length = 0;
        this.vaseOpt.push({ text: "Select an option", value: "" });
        for (const vase of vaseList) {
          console.log("vase:", vase);
          if (vase.node.availableForSale) {
            const variant = vase.node.variants.edges[0].node;
            this.vaseOpt.push({
              text: `${vase.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: vase.node.title,
              id: variant.id,
              price: variant.price.amount
            });
          } else {
            console.log(
              "vase is not availableForSale:",
              vase.node.availableForSale
            );
          }
        }
      } else {
        console.error("vaseList is empty:", vaseList);
      }
    },
    async queryAddons(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const addonsData = {
        queryId: "products_filter",
        productType: "Gift-adds",
        region: warehouseCode,
        dateCode: weekNum
      };
      const addonsList = await this.axios
        .post(inventoryUrl, addonsData)
        .then(res => {
          console.log("query addons response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (addonsList) {
        this.addonsOpt.length = 0;
        this.addonsInventoryOpt.length = 0;
        for (const addons of addonsList) {
          const variant = addons.node.variants?.edges[0]?.node;
          if (addons.node.availableForSale && variant.quantityAvailable > 0) {
            this.addonsInventoryOpt.push({
              text: `${addons.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: {
                value: addons.node.title,
                id: variant.id,
                price: variant.price.amount,
                quantityAvailable: variant.quantityAvailable
              }
            });
          }
        }
      }
    },
    async queryCard(warehouseCode, weekNum) {
      const inventoryUrl =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
        "/pull-automation/inventory";
      const cardData = {
        queryId: "products_with_product_type_filter",
        productType: "Card",
        region: warehouseCode,
        dateCode: weekNum
      };
      const cardList = await this.axios
        .post(inventoryUrl, cardData)
        .then(res => {
          console.log("query card response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `queryVases Exception: ${err}`);
        });
      if (cardList) {
        this.cardOpt.length = 0;
        console.log("cardOpt:", this.cardOpt);
        this.cardOpt.push({ text: "Select an option", value: "" });
        for (const card of cardList) {
          const tags = card.node.tags;
          if (
            card.node.availableForSale &&
            (tags.includes(weekNum) || tags.includes("card-ongoing")) &&
            !tags.includes("not-" + weekNum)
          ) {
            const variant = card.node.variants.edges[0].node;
            this.cardOpt.push({
              text: `${card.node.title} - $${variant.price.amount} (${variant.quantityAvailable})`,
              value: card.node.title,
              id: variant.id,
              price: variant.price.amount,
              quantityAvailable: variant.quantityAvailable
            });
          }
        }
      }
    },
    async queryDeliveryRates(postal, deliveryDate, lang) {
      const postalNew = postal.replace(/\s+/g, "");
      const rateUrl = `https://shop.callia.com/rates/delivery/postalcode/${postalNew}/date/${deliveryDate}?lang=${lang}`;
      const rateList = await this.axios
        .get(rateUrl)
        .then(res => {
          console.log("queryDeliveryRates response:", res.data);
          return JSON.parse(JSON.parse(res.data.body)).sort((a, b) => {
            return (
              Number(a.zone_rate.replace("$", "")) -
              Number(b.zone_rate.replace("$", ""))
            );
          });
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage(
            "warning",
            `queryDeliveryRates Exception: ${err}`
          );
        });
      if (rateList) {
        this.shippingMethodsOpt.length = 0;
        this.shippingMethodsOpt.push({ text: "Select an option", value: "" });
        for (const rate of rateList) {
          if (rate.status === true) {
            this.shippingMethodsOpt.push({
              text: `${rate.display_text} - ${rate.zone_rate.replace(
                ".00",
                ""
              )}`,
              value: rate.display_text,
              price: rate.zone_rate.replace(".00", "")
            });
          }
        }
      }
    },
    selectBouquet() {
      // this.form.bouquetSize = "";
      this.bouquetSizesOpt = this.bouquetSizeObj[this.form.bouquetName];
      if (this.form.bouquetSize) {
        console.log("bouquetSizesOpt", this.bouquetSizesOpt);
        console.log("bouquetSize", this.form.bouquetSize);
        console.log("bouquetSize split", this.form.bouquetSize?.split(" ")[0]);
        const bouquetSizeObj = this.bouquetSizesOpt.find(item =>
          item.value?.includes(this.form.bouquetSize?.split(" ")[0])
        );
        if (bouquetSizeObj) {
          this.form.bouquetSize = bouquetSizeObj.value;
        } else {
          this.form.bouquetSize = "";
        }
      }
    },
    selectAddon() {
      console.log("addons:", this.addons);
      if (this.addons) {
        const orderAddonsObj = this.addonsOpt.find(
          item => item.value.value === this.addons.value
        );
        if (orderAddonsObj) {
          if (orderAddonsObj.value.quantity < this.addons.quantityAvailable) {
            orderAddonsObj.value.quantity++;
            orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                  (x${orderAddonsObj.value.quantity})`;
          }
        } else {
          this.addonsOpt.push({
            text: `${this.addons.value} - $${this.addons.price} (x1)`,
            value: {
              value: this.addons.value,
              id: this.addons.id,
              price: this.addons.price,
              quantity: 1,
              quantityAvailable: this.addons.quantityAvailable
            }
          });
        }
      } else {
        this.displayMessage("warning", `Please select Addons to add`);
      }
    },
    unselectAddon() {
      console.log("this.form.addons:", this.form.addons);
      if (this.form.addons) {
        const orderAddonsObj = this.addonsOpt.find(
          item => item.value.value === this.form.addons.value
        );
        if (this.form.addons.quantity > 1) {
          this.form.addons.quantity--;
          orderAddonsObj.text = `${orderAddonsObj.value.value} - $${orderAddonsObj.value.price}
                                (x${orderAddonsObj.value.quantity})`;
        } else {
          this.addonsOpt = this.addonsOpt.filter(
            item => item.value.value !== this.form.addons.value
          );
        }
      } else {
        this.displayMessage("warning", `Please select Addons to remove`);
      }
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      const dateSelected = dayjs.tz(ymd, "America/Winnipeg");
      const currentTimeStamp = dayjs().tz("America/Winnipeg");
      const today = currentTimeStamp.startOf("day");
      const formatedDate = dateSelected.format("YYYY-MM-DD");
      if (dateSelected.isBefore(today)) {
        return true;
      }
      if (this.availableDates && this.availableDates.length > 0) {
        for (const availableDates of this.availableDates) {
          if (availableDates.date.includes(formatedDate)) {
            const cutOffTimeStamp = dateSelected
              .subtract(parseInt(availableDates.cutoff_effect), "d")
              .startOf("d")
              .add(availableDates.cutoff_time.split(/:|\./)[0], "h")
              .add(availableDates.cutoff_time.split(/:|\./)[1], "m");

            // Date is in the available list — return immediately, skip closedDays check
            return cutOffTimeStamp.isBefore(currentTimeStamp);
          }
        }
      }
      if (this.unavailableDates.includes(formatedDate)) {
        return true;
      }
      if (this.closedDays.includes(weekday)) {
        return true;
      }

      const cutoff = this.cutoffTime.find(df => +df.day === dateSelected.day());
      //Calculate the cutoff time (d - cutoff_effect)
      if (cutoff) {
        const cutOffTimeStamp = dateSelected
          .subtract(parseInt(cutoff.cutoff_effect), "d")
          .startOf("d")
          .add(cutoff.cutoff_time.split(/:|\./)[0], "h")
          .add(cutoff.cutoff_time.split(/:|\./)[1], "m");

        return cutOffTimeStamp.isBefore(currentTimeStamp);
      } else {
        console.log("no cutoff", dateSelected.day());
        return true;
      }
    },
    extractWeekNumber(date) {
      let weekNum = date.format("WW");
      // //Check if weekcode around beginning of year needs correction.
      if ((weekNum == "52" || weekNum == "53") && date.month() == 0) {
        weekNum = weekNum + date.subtract(1, "year").format("YY");
      } else if (weekNum == 1 && date.month() == 11) {
        weekNum = weekNum + date.add(1, "year").format("YY");
      } else {
        weekNum = weekNum + date.format("YY");
      }
      return weekNum;
    },
    async createOrder() {
      this.result = "";
      if (!this.checkItems()) {
        return;
      }
      const deliveryDate = dayjs.tz(
        this.form.deliveryDateNew,
        "America/Winnipeg"
      );
      this.form.deliveryDate = deliveryDate.format("MM/DD/YYYY");
      const deliveryDateObj = dayjs(this.form.deliveryDateNew);
      const weekNum = this.extractWeekNumber(deliveryDateObj);
      const warehouseCode = this.form.regionCode;
      const params = {};
      params.firstName = this.form.firstName;
      params.lastName = this.form.lastName;
      params.deliveryAddress = this.form.address;
      params.addressType = this.form.addressType;
      params.apartmentNumber = this.form.apartmentNumber;
      params.city = this.form.city;
      params.provinceCode = this.provinceMap[this.form.province];
      params.postalCode = this.form.postalCode;
      params.cardMessage = this.form.message;
      params.deliveryDate = this.form.deliveryDate;
      params.deliveryNotes = this.form.deliveryNotes;
      params.contactNumber = this.form.phoneNumber;
      params.contactName = this.form.cName;
      params.regionCode = this.form.regionCode;
      params.alertsEmail = this.form.alertsEmail;
      params.locale = this.form.lang;
      params.discountCode = this.form.discountCode;
      params.deliveryRate = this.form.deliveryRate;
      params.occasion = this.form.occasion;
      params.relationship = this.form.relationship;
      params.sender = this.order.sender;
      params.sender.email = this.form.email;
      const products = [];

      const productBouquet = {};
      productBouquet.productTitle = this.form.bouquetName;
      productBouquet.variantTitle = this.form.bouquetSize;
      productBouquet.productType = "Flowers";
      productBouquet.weekCode = weekNum;
      productBouquet.warehouse = warehouseCode;
      productBouquet.quantity = 1;
      products.push(productBouquet);

      const productCard = {};
      if (this.form.cardType === "Blank Card") {
        this.form.cardType = "Flowers";
      }
      productCard.productTitle = this.form.cardType;
      productCard.variantTitle = "Default Title";
      productCard.productType = "Card";
      productCard.weekCode = weekNum;
      productCard.warehouse = warehouseCode;
      productCard.quantity = 1;
      products.push(productCard);

      if (
        this.form.vase &&
        this.vaseOpt.find(item => item.value === this.form.vase)
      ) {
        const product = {};
        product.productTitle = this.form.vase;
        product.variantTitle = "Default Title";
        product.productType = "Vase";
        product.weekCode = weekNum;
        product.warehouse = warehouseCode;
        product.quantity = 1;
        products.push(product);
      }

      if (this.addonsOpt && this.addonsOpt.length > 0) {
        for (const addon of this.addonsOpt) {
          if (addon && addon.value) {
            const product = {};
            product.productTitle = addon.value.value;
            product.variantTitle = "Default Title";
            product.productType = "Gift-adds";
            product.weekCode = weekNum;
            product.warehouse = warehouseCode;
            product.quantity = addon.value.quantity;
            products.push(product);
          }
        }
      }

      params.products = products;
      params.tags = [
        "REPLACEMENT_AUTOMATION",
        `ORIGINAL_ORDER_${this.order.orderId}`
      ];
      params.note = this.form.note;
      params.noteToOriginalOrder = this.form.noteToOriginalOrder;
      params.noteAttributes = [
        {
          name: "originalOrder",
          value: this.order.orderId
        }
      ];
      if (
        this.form.discountCode &&
        this.form.discountCode.toUpperCase() === "MINIBOUQUET"
      ) {
        params.noteAttributes.push({
          name: "bouquet",
          value: "BOUQUET - MINI"
        });
      }
      const user = this.$store.getters.currentUser;
      params.alertsEmail = user.email;

      this.result = JSON.stringify(params, null, 2);
      this.displayMessage("Success", "Replacing order...");

      // Sender reachout email validation
      if (this.senderReachout.enabled === "true") {
        if (!this.senderReachout.subject.trim()) {
          this.displayMessage(
            "warning",
            "Please input a reachout email subject"
          );
          this.$refs["senderReachoutSubject"].$el.focus();
          return;
        }
        if (!this.senderReachout.body.trim()) {
          this.displayMessage("warning", "Please input a reachout email body");
          this.$refs["senderReachoutBody"].$el.focus();
          return;
        }
        params.senderReachout = {
          sendConfirmationEmail: true,
          emailSubject: this.senderReachout.subject,
          emailBody: this.senderReachout.body
        };
      }

      const url =
        process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/orders/replace";
      await this.axios
        .post(url, params)
        .then(res => {
          console.log("Order Replacement response:", res.data);
          this.displayMessage("Success", "Order Replacement: Done...");
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage("warning", `Order Replacement Exception: ${err}`);
        });
    },
    hideError() {
      this.alert.error = false;
    },
    hideSuccess() {
      this.alert.success = false;
    },
    applyMessageTemplate(value) {
      if (value) {
        this.form.message = value;
      }
    },
    onSenderReachoutSelect(value) {
      const senderName = this.order.sender?.first_name || "there";
      const recipientName = this.form.firstName || this.order.firstName || "";
      const deliveryDate =
        this.form.deliveryDateNew || this.order.deliveryDate || "";

      if (value === "Minibouquet") {
        this.senderReachout.subject = "A Little Something Extra 💐";
        this.senderReachout.body =
          `Hi ${senderName},\n\n` +
          `Just a quick note to let you know I'm sending out some fresh stems for ${recipientName}, which will be delivered on ${deliveryDate}. A little birdie mentioned, these weren't as perfect as they should be! So I wanted to send some extras to help spruce it up for them.\n\n` +
          `And as an added apology, here's a $10 gift card you can use on a future order, on me: M610FORYOU 😊\n\n` +
          `Thanks so much for your understanding! 💐\n\n` +
          `Caitlin`;
      } else if (value === "FullReplacement") {
        this.senderReachout.subject = "Replacement Bouquet on the Way 💐";
        this.senderReachout.body =
          `Hi ${senderName},\n\n` +
          `A little birdie mentioned the blooms didn't arrive quite as perfectly as intended. I'm so sorry about this!\n\n` +
          `I've arranged a replacement bouquet for ${recipientName}, which will be delivered on ${deliveryDate}.\n\n` +
          `And as an added apology, here's a $15 gift card you can use on a future order, on me: M615FORYOU 😊\n\n` +
          `Thanks so much for your understanding! 💐\n\n` +
          `Caitlin`;
      } else if (value === "MissingAddon") {
        this.senderReachout.subject = "Missing Add-On on the Way 🎁";
        this.senderReachout.body =
          `Hi ${senderName},\n\n` +
          `A little birdie mentioned we missed including something with your bouquet for ${recipientName} - I'm so sorry!\n\n` +
          `I've arranged delivery of the missing item for ${recipientName} on ${deliveryDate}. And as an added apology, here's a $10 gift card you can use on a future order, on me: M610FORYOU 😊\n\n` +
          `Thanks so much for your understanding! 💐\n\n` +
          `Caitlin`;
      }
    },
    extractPostalCodeFromAddress() {
      if (!this.form.address) {
        return;
      }

      // Canadian postal code pattern: A1A 1A1 or A1A1A1
      const postalCodeRegex = /[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d/g;
      const matches = this.form.address.match(postalCodeRegex);

      if (matches && matches.length > 0) {
        // Get the last match (postal codes are typically at the end of addresses)
        const extractedPostalCode = matches[matches.length - 1]
          .replace(/\s/g, "")
          .toUpperCase();

        // Format as A1A 1A1
        const formattedPostalCode = extractedPostalCode.replace(
          /([A-Z]\d[A-Z])(\d[A-Z]\d)/,
          "$1 $2"
        );

        // Only update if postal code field is empty or different
        if (
          !this.form.postalCode ||
          this.form.postalCode !== formattedPostalCode
        ) {
          this.form.postalCode = formattedPostalCode;
          console.log("Auto-populated postal code:", formattedPostalCode);
        }
      }
    },
    loadGoogleMapsAPI() {
      return new Promise((resolve, reject) => {
        // Check if already loaded
        if (window.google && window.google.maps && window.google.maps.places) {
          console.log("Google Maps API already loaded");
          this.googleMapsLoaded = true;
          this.$nextTick(() => {
            this.initAutocomplete();
          });
          resolve();
          return;
        }

        // Check if script is already being loaded
        if (this.googleMapsLoaded) {
          resolve();
          return;
        }

        // Get API key from environment variable
        const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

        if (!apiKey) {
          console.warn(
            "Google Maps API key not found in environment variables. Address autocomplete will not be available."
          );
          resolve(); // Don't reject, just continue without autocomplete
          return;
        }

        // Create script element
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=Function.prototype`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
          console.log("Google Maps API loaded successfully");
          this.googleMapsLoaded = true;
          this.$nextTick(() => {
            this.initAutocomplete();
          });
          resolve();
        };

        script.onerror = error => {
          console.error("Failed to load Google Maps API:", error);
          resolve(); // Don't reject, just continue without autocomplete
        };

        document.head.appendChild(script);
      });
    },
    initAutocomplete() {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error("Google Maps API not loaded");
        return;
      }

      const input = this.$refs.addressInput?.$el;
      if (!input) {
        console.error("Address input not found");
        return;
      }

      // Create autocomplete instance restricted to Canada
      this.autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "ca" },
        fields: ["address_components", "formatted_address", "geometry"],
        types: ["address"]
      });

      // Listen for place selection
      this.autocomplete.addListener("place_changed", () => {
        this.handlePlaceSelect();
      });

      console.log("Google Maps Autocomplete initialized for Canada");
    },
    async handlePlaceSelect() {
      const place = this.autocomplete.getPlace();

      if (!place || !place.address_components) {
        console.log("No place details available");
        return;
      }

      console.log("Selected place:", place);

      // Extract address components
      let streetNumber = "";
      let route = "";
      let city = "";
      let province = "";
      let provinceLong = "";
      let postalCode = "";
      let country = "";

      for (const component of place.address_components) {
        const types = component.types;

        if (types.includes("street_number")) {
          streetNumber = component.long_name;
        }
        if (types.includes("route")) {
          route = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        }
        if (types.includes("administrative_area_level_1")) {
          province = component.short_name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, ""); // e.g., "ON"
          provinceLong = component.long_name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, ""); // e.g., "Ontario"
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.short_name;
        }
      }

      // Verify it's a Canadian address
      if (country !== "CA") {
        this.displayMessage("warning", "Please select a Canadian address");
        return;
      }

      console.log("Extracted components:", {
        streetNumber,
        route,
        city,
        province,
        provinceLong,
        postalCode,
        country
      });

      // Build street address
      const streetAddress = `${streetNumber} ${route}`.trim();

      // Update form fields
      this.form.address = streetAddress;

      if (postalCode) {
        // Format postal code as A1A 1A1
        const formattedPostalCode = postalCode
          .replace(/\s/g, "")
          .toUpperCase()
          .replace(/([A-Z]\d[A-Z])(\d[A-Z]\d)/, "$1 $2");
        this.form.postalCode = formattedPostalCode;
        console.log("Set postal code:", formattedPostalCode);
      }

      // Update province if it matches
      if (province || provinceLong) {
        // Try to find province by short name (ON) or long name (Ontario)
        const provinceObj = this.provincesOpt.find(
          p =>
            p.value === province ||
            p.value === provinceLong ||
            p.text === province ||
            p.text === provinceLong
        );

        if (provinceObj) {
          console.log("Found province:", provinceObj);
          this.form.province = provinceObj.value;

          // Trigger province selection to load cities
          this.selectProvince();

          // Wait for cities to load
          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 100));

          if (city) {
            // Try to find matching city in the options
            const normalizedCity = city
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");

            console.log("Looking for city:", normalizedCity);
            console.log("Available cities:", this.citiesOpt);

            // Look for city with region code - try multiple matching strategies
            let cityOption = this.citiesOpt.find(c => {
              const cityName = c.split("(")[0].trim();
              return cityName.toLowerCase() === normalizedCity.toLowerCase();
            });

            // If not found, try without normalization
            if (!cityOption) {
              cityOption = this.citiesOpt.find(c => {
                const cityName = c.split("(")[0].trim();
                return cityName.toLowerCase() === city.toLowerCase();
              });
            }

            // If still not found, try partial match
            if (!cityOption) {
              cityOption = this.citiesOpt.find(c => {
                const cityName = c
                  .split("(")[0]
                  .trim()
                  .toLowerCase();
                const searchCity = normalizedCity.toLowerCase();
                return (
                  cityName.includes(searchCity) || searchCity.includes(cityName)
                );
              });
            }

            if (cityOption) {
              console.log("Found city:", cityOption);
              this.form.city = cityOption;

              // Trigger city selection to load region and other data
              await this.selectCity();

              // Query delivery window if postal code is available
              if (this.form.postalCode && this.form.postalCode.length >= 6) {
                await this.queryDeliveryWindow();
              }
            } else {
              console.warn("City not found in options:", city);
              this.displayMessage(
                "warning",
                `City "${city}" not found in system. Please select manually.`
              );
            }
          }
        } else {
          console.warn(
            "Province not found in options:",
            province,
            provinceLong
          );
          this.displayMessage(
            "warning",
            `Province "${provinceLong ||
              province}" not found. Please select manually.`
          );
        }
      }

      console.log("Auto-populated address fields:", {
        address: streetAddress,
        city: this.form.city,
        province: this.form.province,
        postalCode: this.form.postalCode,
        region: this.form.region
      });

      this.displayMessage("success", "Address auto-populated successfully!");
    },
    checkItems() {
      this.formSubmitted = true;
      const errors = [];

      if (!this.order.orderId) {
        errors.push(`Order Name can't be empty`);
      }
      if (!this.order.email) {
        errors.push(`Please input Order Name and Query Order`);
      }
      if (!this.form.province) {
        errors.push(`Province can't be empty`);
      }
      if (!this.form.city) {
        errors.push(`City can't be empty`);
      }
      if (!this.form.deliveryDateNew) {
        errors.push(`Delivery Date can't be empty`);
      }
      if (!this.form.postalCode) {
        errors.push(`Postal Code can't be empty`);
      } else if (this.form.postalCode.length < 6) {
        errors.push(`Postal Code is invalid`);
      }
      if (!this.form.lang) {
        errors.push(`Lang can't be empty`);
      }
      if (!this.form.firstName) {
        errors.push(`First Name can't be empty`);
      }
      if (!this.form.lastName) {
        errors.push(`Last Name can't be empty`);
      }
      if (!this.form.cName) {
        errors.push(`Contact Name can't be empty`);
      }
      if (!this.form.phoneNumber) {
        errors.push(`Phone Number can't be empty`);
      } else {
        const digits = this.form.phoneNumber.replace(/\D/g, "");
        if (digits.length < 10) {
          errors.push(
            `Phone number is incomplete. Please enter a 10-digit phone number.`
          );
        }
      }
      if (!this.form.address) {
        errors.push(`Address can't be empty`);
      }
      if (
        !this.form.addressType ||
        !this.addressTypesOpt.find(item => item.value === this.form.addressType)
      ) {
        errors.push(`Address Type can't be empty`);
      }
      if (this.isApartmentType && !this.form.apartmentNumber) {
        errors.push(
          `Apartment Number is required for Apartment/Condo address type`
        );
      }
      if (
        !this.form.deliveryRate ||
        !this.shippingMethodsOpt?.find(
          item => item.value === this.form.deliveryRate
        )
      ) {
        errors.push(`Delivery Window can't be empty`);
      }
      if (
        !this.form.bouquetName ||
        !this.bouquetFlatOpt?.find(item => item.value === this.form.bouquetName)
      ) {
        errors.push(`Bouquet Name can't be empty`);
      }
      if (
        !this.form.bouquetSize ||
        !this.bouquetSizesOpt?.find(
          item => item.value === this.form.bouquetSize
        )
      ) {
        errors.push(`Bouquet Size can't be empty`);
      }
      if (!this.form.occasion) {
        errors.push(`Occasion can't be empty`);
      }
      if (!this.form.relationship) {
        errors.push(`Relationship can't be empty`);
      }
      if (!this.form.cardType) {
        errors.push(`Card Type can't be empty`);
      }
      if (!this.form.message) {
        errors.push(`Card Message can't be empty`);
      } else if (this.form.message.length > 900) {
        errors.push(`Card Message must be 900 characters or fewer`);
      }
      if (!this.form.region) {
        errors.push(`Region can't be empty`);
      }

      if (errors.length > 0) {
        // Show first error as toast; all fields are already highlighted via formSubmitted
        this.displayMessage("warning", errors[0]);
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";

.card {
  width: 100%;
  border: none;
}

.report-label {
  font-weight: 600;

  .weight {
    font-weight: 400;
  }

  span {
    font-weight: 400;
  }
}

.upper {
  text-transform: case;
}

#checkbox-group,
.custom-select a:hover,
a:active,
a:focus {
  outline: 0;
}

.page-break {
  width: 100%;
  height: 52px;
}

// Google Maps Autocomplete styling
::v-deep .pac-container {
  z-index: 10000 !important;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  font-family: inherit;
  margin-top: 2px;
}

::v-deep .pac-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f5f5f5;
  }
}

::v-deep .pac-item-query {
  font-weight: 600;
  color: #333;
}

::v-deep .pac-matched {
  font-weight: 700;
}

::v-deep .pac-icon {
  margin-right: 8px;
}

// Invalid state for v-select (city field)
.is-invalid-vselect {
  ::v-deep .vs__dropdown-toggle {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
}
</style>
